var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-slider',{attrs:{"tooltip":"none","rail-style":{
    'background-color': '#E9EBF0'
  },"process-style":{
    'background-color': '#168AE2'
  },"dot-style":{
    'box-shadow': '0.5px 0.5px 2px 1px rgba(0, 0, 0, 0.32)'
  },"height":_vm.baseSize,"dot-size":_vm.baseSize + 10},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }